import classNames from "classnames";
import styles from "./FilterModeSwitcher.module.css";

interface FilterModeSwitcherProps<Mode extends string> {
  modes: { value: Mode; label: string }[];
  active: Mode;
  onSelect: (mode: Mode) => void;
}

// The row of mode buttons (Equals/Range/Empty, Exact date(s)/Month/Year/Range, ...) shared by
// Number and Date filters - only one mode is ever active at a time.
const FilterModeSwitcher = <Mode extends string>({ modes, active, onSelect }: FilterModeSwitcherProps<Mode>) => (
  <div className={styles.modes}>
    {modes.map((mode) => (
      <button
        key={mode.value}
        type="button"
        className={classNames(styles.mode, { [styles.modeActive]: mode.value === active })}
        onClick={() => onSelect(mode.value)}
      >
        {mode.label}
      </button>
    ))}
  </div>
);

export default FilterModeSwitcher;
